import React from 'react';
import './ThankYou.css';  // Make sure to create a CSS file for styling
import { useNavigate, useLocation } from 'react-router-dom';

const ThankYou = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Get custom message from location state or use default message
    const message = location.state?.message || 
      "Thank you for joining the interview. The interviewer will provide feedback soon.";
      
    // Get phone number if it exists in state
    const phoneNumber = location.state?.phoneNumber;

  return (
    <div className="thank-you-container">
      {/* <img 
        src="https://png.pngtree.com/png-vector/20230105/ourmid/pngtree-cute-thank-you-for-fun-design-png-image_6551638.png"  // Replace with an actual image URL
        alt="Thank you" 
        className="thank-you-image" 
      /> */}
      <h1 className="thank-you-title">Thank You!</h1>
      <p className="thank-you-message">
        {message}
      </p>
      
      {/* Show phone number if available */}
      {phoneNumber && (
        <p className="phone-details">
          We will call you at: <strong>{phoneNumber}</strong>
        </p>
      )}
      
      <button className="go-back-button" onClick={() => navigate("/")}>
        Back to Home
      </button>
    </div>
  );
};

export default ThankYou;
